import { combineReducers } from '@fullstory/redux-util/utils';
import { Dimension } from '@fullstory/proto/fs/services/alexa';
import { createErrorReducer, createLoadingReducer } from '@fullstory/redux-util';
import { ImpactTypes } from '../types';
import { ImpactDimensionsActions } from '../actions';

const loading = createLoadingReducer(
  ImpactTypes.ComputeDimensionsRequest,
  ImpactTypes.ComputeDimensionsSuccess,
  ImpactTypes.ComputeDimensionsFailure,
);

const error = createErrorReducer(
  ImpactTypes.ComputeDimensionsRequest,
  ImpactTypes.ComputeDimensionsSuccess,
  ImpactTypes.ComputeDimensionsFailure,
);

function list(state: Dimension[] = [], action: ImpactDimensionsActions): Dimension[] {
  switch (action.type) {
    case ImpactTypes.ComputeDimensionsRequest:
      return [];
    case ImpactTypes.ComputeDimensionsSuccess:
      return state.concat(action.data.dimensions);
  }
  return state;
}

type DimensionsState = {
  loading: ReturnType<typeof loading>;
  error: ReturnType<typeof error>;
  list: ReturnType<typeof list>;
};

export const dimensions = combineReducers<DimensionsState>({
  loading,
  error,
  list,
});
